/**
 * Builds 1–2 character initials from a person's names for avatar fallbacks.
 */
export function getInitials(
    firstName?: string | null,
    lastName?: string | null,
    fullName?: string | null,
): string {
    const first = firstName?.trim()[0];
    const last = lastName?.trim()[0];
    if (first && last) {
        return `${first}${last}`.toLocaleUpperCase();
    }

    const parts = (fullName ?? "").trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
        const start = parts[0][0];
        const end = parts[parts.length - 1][0];
        if (start && end) {
            return `${start}${end}`.toLocaleUpperCase();
        }
    }

    if (parts[0]?.[0]) {
        return parts[0].slice(0, 2).toLocaleUpperCase();
    }

    if (first) {
        return first.toLocaleUpperCase();
    }

    return "";
}
